import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ChevronDownIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="10px"
          height="7px"
          viewBox="0 0 10 7"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon
              id="chevron-down-icon"
              points="12 15.3515625 7 10.3515625 8.171875 9.1796875 12 13.0078125 15.828125 9.1796875 17 10.3515625"
            ></polygon>
          </defs>
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-851.000000, -2831.000000)"
            >
              <g id="General-Icons" transform="translate(56.000000, 753.000000)">
                <g id="row" transform="translate(0.000000, 2031.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="general-/-chevron-down-/-Default"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#chevron-down-icon"></use>
                      </mask>
                      <use
                        id="chevron-down"
                        fill="currentColor"
                        xlinkHref="#chevron-down-icon"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

ChevronDownIcon.propTypes = {
  className: PropTypes.string,
};

export default ChevronDownIcon;
